import { render, staticRenderFns } from "./BoCustomerGeneralInformations.vue?vue&type=template&id=15e2870d"
import script from "./BoCustomerGeneralInformations.vue?vue&type=script&lang=js"
export * from "./BoCustomerGeneralInformations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports